<template>
  <v-container class="px-12">
    <v-row>
      <v-col cols="12" lg="6" offset-lg="3">
        <BaseTitle class="mt-16 mb-6">
          {{ $t('Forgotten password title')}}
        </BaseTitle>
        <form @submit.prevent="submit">
          <v-text-field class="mb-2" v-model="email" :label="$t('Email')" type="email" required />
          <v-btn color="primary" class="mb-8" block bottom type="submit">
            Envoyer
          </v-btn>
          <div class="text-center">
            <router-link to="/connexion">
              {{ $t('Sign in')}}
            </router-link>
          </div>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'PasswordForgotten',
  components: {
    BaseTitle,
  },
  computed: mapFields('authentication', ['form.email']),
  methods: {
    ...mapActions('authentication', ['askForPasswordReset']),
    ...mapMutations(['setAlert']),
    submit() {
      this.askForPasswordReset()
        .then(() => {
          this.$router.push('/connexion');
          this.setAlert({
            text: 'Vous allez recevoir un email contenant un lien de réinitialisation de votre mot de passe',
            color: 'success',
            show: true,
          });
        })
        .catch(() => {
          this.setAlert({
            text: 'Une erreur s\'est produite',
            color: 'warning',
            show: true,
          });
        });
    },
  },
};
</script>
